import React  from "react";
import Joi from "joi-browser";
import { toast } from "react-toastify";
import { Form, Button, Spinner } from "react-bootstrap";
import {addSale} from "../services/saleService";
import FormComponent from './common/formComponent';

class SaleSummary extends FormComponent {
  state = {
    data: { type: "Sale", items: this.props.items, userId: undefined, sendEmail: true },
    errors: {},
    processing: false,
  };

  schema = {
    type: Joi.string()
      .required()
      .label("Type"),
    items: Joi.array().min(1)
      .required()
      .label("Sale Items"),
    userId: Joi.string()
      .required()
      .label("User Id"),
    sendEmail: Joi.boolean()
    .required()
    .label("Send Email"),
  };

  componentWillReceiveProps(nextProps) {
    this.setState({ data: { type: "Sale", items: nextProps.items, userId: nextProps.customerId,  sendEmail: true } });
  }

  doSubmit = async () => {
    this.setState({ processing: true });
    try {
      await addSale(this.state.data);
      toast.success(`Invoice Saved Successfully`);

      this.props.callBackFromParent();
      this.setState({ processing: false, data: { type: "sale", items: [] } });
    } catch (ex) {
      if (ex.response && (ex.response.status >= 400 && ex.response.status < 500)) {
        toast.error(ex.response.data);
        this.setState({ processing: false});
      }
    }
  };

  removeItem = (item) => {
    const { items: originalItems } = this.state.data;
    const newItems = originalItems.filter((i) => i !== item);
    this.setState({ data: { items: newItems } });
  };

  render() {
    const { data, processing } = this.state;
    const { total } = this.props;
    const formatter = new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0
    });

    return (
      <div className="card mb-3">
        <div className="card-header">
          <i className="fas fa-table mr-2" />
          Sale Summary - &#x20A6;{formatter.format(total)}
        </div>
        <div className="card-body">
          {data.items.length === 0 && <span className="small text-muted">No items to display</span>}
          {data.items.length > 0 && (
            <React.Fragment>
              <div className="table-responsive">
                <table className="table table-bordered table-striped" id="dataTable" width="100%" cellSpacing="0">
                  <thead className="thead-dark">
                    <tr>
                      <th>Item</th>
                      <th>Quantity</th>
                      <th>Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.items.map((item) => (
                      <tr key={item.itemId}>
                        <td>{item.name}</td>
                        <td>{item.quantity}</td>
                        <td>&#x20A6;{formatter.format(item.amount)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </React.Fragment>
          )}
        </div>
        <div className="card-footer">
          <Form onSubmit={this.handleSubmit}>
            <button type="button" onClick={this.props.callBackFromParent} className="btn btn-secondary btn-block mb-3">
              Cancel
            </button>

            <Form.Check
              className="mb-3"
              name="sendEmail"
              type="switch"
              id="customControlAutosizing"
              label="Send Invoice By email to Customer"
              onChange={this.handleToggle}
              checked={data["sendEmail"]}
              custom
            />
            <Button type="submit" block disabled={this.validate() || processing}>
              {processing && (
                <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
              )}
              Save Invoice
            </Button>
          </Form>
        </div>
      </div>
    );
  }
}

export default SaleSummary;